import { css } from "@emotion/react";

export const inputStyles = ({ theme, darkBackground, isNewsletter }) => css`
    background-color: transparent;
    color: ${darkBackground
        ? theme.colors.typography.defaultDarkBackground
        : theme.colors.typography.defaultLightBackground};
    font-size: 1.6rem;
    font-weight: 500;
    border: 1px solid
        ${darkBackground
            ? theme.colors.typography.defaultDarkBackground
            : theme.colors.typography.defaultLightBackground};
    padding: 10px;
    width: 100%;
    margin-bottom: ${isNewsletter ? `15px` : `0`};

    &::placeholder {
        font-size: 1.5rem;
        font-weight: 500;
        font-style: italic;
        color: ${darkBackground
            ? theme.colors.typography.defaultDarkBackground
            : theme.colors.typography.defaultLightBackground};
    }

    @media (min-width: ${theme.breakpoints.mobileLandscape}) {
        padding: 20px;
    }
`;

export const textareaStyles = ({ theme }) => css`
    height: auto;
    padding: 10px;
    resize: vertical;
    min-height: 150px;

    @media (min-width: ${theme.breakpoints.mobileLandscape}) {
        padding: 20px;
    }
`;
